import { client } from './client'
import type {
  TokenAnalyticsByWorkflow,
  TokenAnalyticsByUser,
  CopilotAnalyticsByWorkflow,
  CopilotAnalyticsByUser,
} from '@/types/analytics'

export const getTokenAnalyticsByWorkflow = (
  projectId: string,
  params: { from?: string; to?: string }
) =>
  client
    .get<TokenAnalyticsByWorkflow>(`/projects/${projectId}/analytics/token-usage/claude/by-workflow`, { params })
    .then(res => res.data)

export const getTokenAnalyticsByUser = (
  projectId: string,
  params: { from?: string; to?: string }
) =>
  client
    .get<TokenAnalyticsByUser>(`/projects/${projectId}/analytics/token-usage/claude/by-user`, { params })
    .then(res => res.data)

export const getCopilotAnalyticsByWorkflow = (
  projectId: string,
  params: { from?: string; to?: string }
) =>
  client
    .get<CopilotAnalyticsByWorkflow>(`/projects/${projectId}/analytics/token-usage/copilot/by-workflow`, { params })
    .then(res => res.data)

export const getCopilotAnalyticsByUser = (
  projectId: string,
  params: { from?: string; to?: string }
) =>
  client
    .get<CopilotAnalyticsByUser>(`/projects/${projectId}/analytics/token-usage/copilot/by-user`, { params })
    .then(res => res.data)
